import React from 'react';
import './questionDisplay.scss';
import { useIsMobile } from '../../hooks/isMobile';
import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';

const QuestionDisplay = ({ questionNumber, question, selectedAnswer, onAnswerSelect }) => {
  const storeVar = useSelector(state => state.question)
  const isMobile = useIsMobile();
  const renderQuestion = () => {
    if (typeof question === 'string') {
      return (
        <div className="question-body">
          <p className="question-text">{question.questionEnglish}</p>
          <div className="radio-group">
            {/* {["Kirsty Coventry", "PT Usha", "Katie Ledecky", "Larisa Latynina", "Anju Bobby George"].map((value, idx) => (
              <div key={value} className="radio-option">
                <input
                  type="radio"
                  value={value}
                  id={`option-${idx}`}
                  checked={selectedAnswer === value}
                  onChange={() => onAnswerSelect(value)}
                />
                <label style={{marginBottom:0}}htmlFor={`option-${idx}`}>{value}</label>
              </div>
            ))} */}
          </div>
        </div>
      );
    } else if (question.type === 'matching') {
      return (
        <div className="matching-body">
          <p className="matching-instruction">
            Directions: In the following question, two columns are given containing three phrases each.
            The phrases are labeled A, B, and C in the first column and P, Q, and R in the second column.
            Identify the correct option given below that gives the correct sequence in which one or more
            sentences can be formed.
          </p>
          <div className="matching-table">
            <table>
              <thead>
                <tr>
                  <th>Column-1</th>
                  <th>Column-2</th>
                </tr>
              </thead>
              <tbody>
                {/* {question.columnA.map((itemA, index) => (
                  <tr key={itemA.id}>
                    <td>({itemA.id}) {itemA.content}</td>
                    <td>
                      {question.columnB[index] && (
                        <>({question.columnB[index].id}) {question.columnB[index].content}</>
                      )}
                    </td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </div>
          <div className="radio-group">
            {["A-P", "B-Q", "B-R and C-Q", "A-P and C-Q", "None of these"].map((value, idx) => (
              <div key={value} className="radio-option">
                <input
                  type="radio"
                  value={value}
                  id={`matching-${idx}`}
                  checked={selectedAnswer === value}
                  onChange={() => onAnswerSelect(value)}
                />
                <label htmlFor={`matching-${idx}`}>{value}</label>
              </div>
            ))}
          </div>
        </div>
      );
    } else {
      return (
        <div className="question-body">
          <p
            className="question-text"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(storeVar.examLanguage === 'english'
              ? question.questionEnglish
              : question.questionBengali) }}
          ></p>
          <div className="radio-group">
            <div key={1} className="radio-option">
              <input
                type="radio"
                value={1}
                id={`option-${1}`}
                checked={selectedAnswer === 1}
                onChange={() => onAnswerSelect(1)}
              />
              <label htmlFor={`option-${1}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(storeVar.examLanguage === 'english'
              ? question.answer1English
              : question.answer1Bengali) }}></label>
            </div>
            <div key={2} className="radio-option">
              <input
                type="radio"
                value={2}
                id={`option-${2}`}
                checked={selectedAnswer === 2}
                onChange={() => onAnswerSelect(2)}
              />
              <label htmlFor={`option-${2}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(storeVar.examLanguage === 'english'
              ? question.answer2English
              : question.answer2Bengali) }}></label>
            </div>
            <div key={3} className="radio-option">
              <input
                type="radio"
                value={3}
                id={`option-${3}`}
                checked={selectedAnswer === 3}
                onChange={() => onAnswerSelect(3)}
              />
              <label htmlFor={`option-${3}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(storeVar.examLanguage === 'english'
              ? question.answer3English
              : question.answer3Bengali) }}></label>
            </div>
            <div key={4} className="radio-option">
              <input
                type="radio"
                value={4}
                id={`option-${4}`}
                checked={selectedAnswer === 4}
                onChange={() => onAnswerSelect(4)}
              />
              <label htmlFor={`option-${4}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(storeVar.examLanguage === 'english'
              ? question.answer4English
              : question.answer4Bengali) }}></label>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="question-card">
      <div className="question-header">
        <span className="question-number">Question No. {questionNumber}</span>
        {/* <div className="marks-info">
          <span>Marks</span>
          <span className="mark-positive">+{storeVar.questionDetails?.lessonId?.mockTestId?.correctMarks}</span>
          <span className="mark-negative">-{storeVar.questionDetails?.lessonId?.mockTestId?.inCorrectMarks}</span>
        </div> */}
      </div>
      {renderQuestion()}
    </div>
  );
};

export default QuestionDisplay;
